export default "__VITE_ASSET__647a3243__"